import { FieldsOfRelevanceEnum } from '@collections/common/enums/fields-of-relevance.enums';
import { LabelValue } from './labelValue.model';
export const FieldsOfRelevances: LabelValue<FieldsOfRelevanceEnum>[] = [
  { label: $localize`Wire`, value: FieldsOfRelevanceEnum.wire },
  { label: $localize`Cable`, value: FieldsOfRelevanceEnum.cables },
  { label: $localize`Ropes`, value: FieldsOfRelevanceEnum.ropes },
  { label: $localize`Fasteners`, value: FieldsOfRelevanceEnum.fasteners },
  { label: $localize`Springs`, value: FieldsOfRelevanceEnum.springs },
  { label: $localize`Tube`, value: FieldsOfRelevanceEnum.tubes },
  { label: $localize`Profiles`, value: FieldsOfRelevanceEnum.profiles },
  { label: $localize`Sheet metal`, value: FieldsOfRelevanceEnum.sheetMetal },
  { label: $localize`Chip removal`, value: FieldsOfRelevanceEnum.smallMetalParts },
];
